import gql from 'graphql-tag'

export const getLoans = gql`
    query GET_LOANS($input: ListLoanApplicationsFromNodeInput) {
        listLoanApplicationsFromNode(input: $input) {
            data {
                data {
                    term
                    principal
                    prequalification_amount
                    ltv_ratio
                    last_updated
                    iso_currency_code
                    interest_rate
                    interest
                    fees
                    date
                    amount
                }
                institution_id
                loan_application_id
                loan_product
                name
                loan_purpose
                status
            }
        }
    }
`
